import React from 'react';
import { MapPin, Leaf } from 'lucide-react';
import { presence } from '../mock';

const Presence = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-200 bg-emerald-50 text-emerald-700 text-xs font-semibold uppercase tracking-widest">
            <Leaf className="w-3.5 h-3.5" /> Indian Energreen Presence
          </div>
          <h2 className="mt-5 text-4xl md:text-5xl font-extrabold text-[#0b1a1a] leading-tight">
            Our Live Plants & Presence <span className="text-emerald-600">Across India</span>
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            From farm-to-fuel, our network of operational CBG plants spans every corner of the country — bringing reliable clean energy where it's needed most.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-5 gap-8 items-center">
          {/* Map visual */}
          <div className="lg:col-span-3 relative aspect-[4/3] bg-gradient-to-br from-emerald-50 to-lime-50 rounded-3xl border border-emerald-100 overflow-hidden">
            <svg viewBox="0 0 400 400" className="absolute inset-0 w-full h-full">
              {/* simplified India outline */}
              <path d="M120 60 L180 50 L230 70 L280 90 L310 130 L320 180 L300 230 L320 280 L290 320 L240 340 L210 370 L180 360 L160 320 L130 290 L110 250 L90 200 L100 150 L110 100 Z"
                    fill="#10b981" fillOpacity="0.15" stroke="#10b981" strokeWidth="2" />
              {/* dots */}
              {[{x:170,y:130},{x:200,y:180},{x:160,y:200},{x:140,y:170},{x:220,y:230},{x:200,y:280},{x:240,y:300},{x:180,y:330},{x:260,y:170},{x:280,y:220}].map((d,i)=>(
                <g key={i}>
                  <circle cx={d.x} cy={d.y} r="12" fill="#10b981" fillOpacity="0.25">
                    <animate attributeName="r" from="8" to="18" dur="2s" repeatCount="indefinite" />
                    <animate attributeName="fill-opacity" from="0.4" to="0" dur="2s" repeatCount="indefinite" />
                  </circle>
                  <circle cx={d.x} cy={d.y} r="4" fill="#10b981" />
                </g>
              ))}
            </svg>
            <div className="absolute top-6 left-6 bg-white rounded-xl shadow-lg p-3 flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse" />
              <span className="text-xs font-bold text-[#0b1a1a]">56+ Live Plants</span>
            </div>
          </div>

          <div className="lg:col-span-2 grid grid-cols-2 gap-3">
            {presence.map((p) => (
              <div key={p.state} className="bg-white border border-slate-100 rounded-xl p-4 hover:border-emerald-300 hover:shadow-md transition-all">
                <div className="flex items-center gap-2">
                  <MapPin className="w-4 h-4 text-emerald-600" />
                  <div className="font-bold text-[#0b1a1a] text-sm">{p.state}</div>
                </div>
                <div className="mt-1 text-xs text-slate-500">{p.plants} active plants</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Presence;
